import { render, staticRenderFns } from "./wlmz-jzjl-make.vue?vue&type=template&id=6724fe14&scoped=true&"
import script from "./wlmz-jzjl-make.vue?vue&type=script&lang=js&"
export * from "./wlmz-jzjl-make.vue?vue&type=script&lang=js&"
import style0 from "./wlmz-jzjl-make.vue?vue&type=style&index=0&id=6724fe14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724fe14",
  null
  
)

export default component.exports